import * as React from 'react';

import { useRecordNuxGoalFact } from './mutations/useRecordNuxGoalFact';

import type { NuxGoalClientFactKind } from '../__generated__/globalTypes';

/**
 * Reports, once per mount, that the member opened a page, so their NUX goals
 * can count it. `targetId` is the record the page shows: `undefined` until it
 * has loaded, so a page that never finds its record reports nothing, and `null`
 * for a page about no one record. A different target reports again. A failed
 * report is dropped, since measurement must never break the page.
 */
export function useRecordPageVisit(kind: NuxGoalClientFactKind, targetId: string | null | undefined): void {
  const [recordNuxGoalFact] = useRecordNuxGoalFact();
  const reportedKey = React.useRef<string | null>(null);

  React.useEffect(() => {
    if (targetId === undefined) {
      return;
    }
    const key = `${kind}:${targetId ?? ''}`;
    if (reportedKey.current === key) {
      return;
    }
    reportedKey.current = key;
    void recordNuxGoalFact({ variables: { input: { kind, targetId } } }).catch(() => undefined);
  }, [kind, targetId, recordNuxGoalFact]);
}
